import { render, staticRenderFns } from "./vesselOwners.vue?vue&type=template&id=858ddc40&scoped=true"
import script from "./vesselOwners.vue?vue&type=script&lang=js"
export * from "./vesselOwners.vue?vue&type=script&lang=js"
import style0 from "./vesselOwners.vue?vue&type=style&index=0&id=858ddc40&prod&lang=scss"
import style1 from "./vesselOwners.vue?vue&type=style&index=1&id=858ddc40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858ddc40",
  null
  
)

export default component.exports